import { useContext } from "react";
import { ViewContext, type ViewContextType } from "../context/viewContext/viewContext";

export const useViewContext = (): ViewContextType => {
    const context = useContext(ViewContext);

    if (context === undefined) {
        throw new Error(
            "useViewContext must be used within a ViewContextProvider."
        );
    }

    return context;
};
